//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/file_uploader'
import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'

//#endregion

import { i18n } from './../i18n/common.i18n'
import { LocalizationHelper } from '../../../helpers'

//#region Assets Imports

import './file-uploader.scss'
import * as TEMPLATE from './file-uploader.tpl.html'

//#endregion

export interface FileUploaderOptions {
    acceptValue: string
    uploaderVisible: boolean
    readAsText?: boolean
    onReadEnd?: (reader, fileName) => void
    onSubmitClick?: () => void
    resetAfterReadEnd?: boolean
    disabled?: boolean
    submitButtonDisabled?: boolean
    customButtonOptions?: DevExpress.ui.dxButtonOptions
}

interface FileUploaderScope extends ng.IScope {
    uploaderOptions: DevExpress.ui.dxFileUploaderOptions
    uploader: DevExpress.ui.dxFileUploader
    cancelFileButtonOptions: DevExpress.ui.dxButtonOptions
    submitFileButtonOptions: DevExpress.ui.dxButtonOptions
    customButtonOptions: DevExpress.ui.dxButtonOptions

    file: File

    submitButtonDisabled: boolean

    options: FileUploaderOptions
    isLoading: boolean
}

export class FileUploaderDirective implements ng.IDirective {
    constructor() { }

    restrict = 'E'

    template = TEMPLATE

    scope = {
        options: '='
    }

    controller = ['$scope', '$timeout', ($scope: FileUploaderScope, $timeout: ng.ITimeoutService) => {
        $scope.options.submitButtonDisabled = true
        $scope.customButtonOptions = $scope.options.customButtonOptions

        const resetUploader = () => {
            if ($scope.uploader != null) {
                $scope.uploader.reset()
            }

            $scope.file = null
            $scope.options.uploaderVisible = true
            $scope.options.submitButtonDisabled = true
        }

        $scope.uploaderOptions = {
            selectButtonText: i18n('Common', 'SelectFile'),
            labelText: i18n('Common', 'DropFileHere'),
            width: '100%',
            height: '100%',
            readyToUploadMessage: i18n('Common', 'ReadyToUpload'),
            uploadMode: 'useForm',
            uploadedMessage: i18n('Common', 'Uploaded'),
            uploadFailedMessage: i18n('Common', 'UploadFailed'),
            showFileList: false,
            bindingOptions: {
                accept: 'options.acceptValue',
                disabled: 'options.disabled'
            },

            onInitialized: e => {
                $scope.uploader = e.component
            },

            onValueChanged: (e) => {
                if (e.value && e.value.length) {
                    $scope.options.uploaderVisible = false
                    $scope.file = e.value[0]
                    $scope.options.submitButtonDisabled = false
                }
                else {
                    $scope.options.uploaderVisible = true
                    $scope.options.submitButtonDisabled = true
                }
            }
        }

        $scope.cancelFileButtonOptions = {
            text: i18n("Common", "Cancel"),

            onClick: () => {
                resetUploader()
            }
        }

        $scope.submitFileButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Upload),
            bindingOptions: {
                disabled: 'options.submitButtonDisabled'
            },

            onClick: () => {
                $scope.isLoading = true
                if ($scope.options.onSubmitClick)
                    $scope.options.onSubmitClick()

                var reader = new FileReader()
                reader.onloadend = (e: any) => {
                    setTimeout(() => {
                        $scope.isLoading = false
                    }, 500)
                    if ($scope.options.onReadEnd) {
                        $scope.options.onReadEnd(reader, $scope.file.name)
                        if ($scope.options.resetAfterReadEnd)
                            resetUploader()
                    }

                    $scope.options.submitButtonDisabled = true
                }

                if ($scope.options.readAsText) {
                    reader.readAsText($scope.file)
                }
                else {
                    reader.readAsDataURL($scope.file)
                }
            }
        }
    }]

    replace = true
}